import { render, staticRenderFns } from "./PublicWallView.vue?vue&type=template&id=c51a21bc&scoped=true&"
import script from "./PublicWallView.vue?vue&type=script&lang=js&"
export * from "./PublicWallView.vue?vue&type=script&lang=js&"
import style0 from "./PublicWallView.vue?vue&type=style&index=0&id=c51a21bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a21bc",
  null
  
)

export default component.exports